import trigger from '../vendor/tiny-trigger'
import forEach from '../lib/foreach'

export default class Toggler {
  constructor(el) {
    this.el = el
    this.active = this.el.classList.contains('-active')
    this.isTab = this.el.getAttribute('data-tabs')
    this.targets = document.querySelectorAll(
      this.el.getAttribute('data-target')
    )
    this.secondaries = document.querySelectorAll(
      this.el.getAttribute('data-secondaries')
    )

    this.el.addEventListener('click', this.toggle.bind(this), false)
  }

  activate() {
    this.el.classList.add('-active')

    forEach(this.targets, target => {
      target.classList.add('-active')
    })

    this.toggleSecondaries()
  }

  deactiveate() {
    this.el.classList.remove('-active')

    forEach(this.targets, target => {
      target.classList.remove('-active')
    })
  }

  toggle(e) {
    e.preventDefault()

    if (this.isTab && this.active && this.secondariesNotToggled()) return

    this.active ? this.deactiveate() : this.activate()

    this.active = !this.active
  }

  secondariesNotToggled() {
    let notToggled = true

    forEach(this.secondaries, secondary => {
      if (secondary.classList.contains('-active') && secondary != this.el) {
        notToggled = false
      }
    })

    return notToggled
  }

  toggleSecondaries() {
    forEach(this.secondaries, secondary => {
      if (secondary.classList.contains('-active') && secondary != this.el) {
        trigger(secondary, 'click')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/javascript/features/toggler.js